import { messageSystemType } from "pages/Messages/components/Conversation/MessagesList/Message/Message.types";

export const actionTypes = {
  SET_FOLDERS: "MSG:SET_FOLDERS",
  SET_DIALOGS: "MSG:SET_DIALOGS",
  SET_MESSAGES: "MSG:SET_MESSAGES",
  RESET_MESSAGES: "MSG:RESET_MESSAGES",
  SET_MESSAGES_MORE: "MSG:SET_MESSAGES_MORE",
  SET_MSG_LOADING: "MSG:SET_LOADING",
  SET_MSG_LOADING_MORE: "MSG:SET_LOADING_MORE",
  SET_USER_PREVIEW: "MSG:SET_USER_PREVIEW",
  SET_EDITING_MESSAGE: "MSG:SET_EDITING_MESSAGE",
  RESET_EDIT_MESSAGE: "MSG:RESET_EDIT_MESSAGE",
  SET_REPLYING_MESSAGE: "MSG:SET_REPLYING_MESSAGE",
  DELETE_MESSAGE: "MSG:DELETE_MESSAGE",
  RESET_REPLYING_MESSAGE: "MSG:RESET_REPLYING_MESSAGE",
  REPLACE_EDIT_MESSAGE: "MSG:REPLACE_EDIT_MESSAGE",
  SET_ID_SELECTED_MESSAGES: "MSG:SET_ID_SELECTED_MESSAGES",
  REPLACE_ID_SELECTED_MESSAGES: "MSG:REPLACE_ID_SELECTED_MESSAGES",
  RESET_ID_SELECTED_MESSAGES: "MSG:RESET_ID_SELECTED_MESSAGES",
  RESET_CURRENT_USER: "MSG:RESET_CURRENT_USER",
  SET_END_OF_MESSAGES: "MSG:SET_END_OF_MESSAGES",
  ADD_NEW_MSG: "MSG:ADD_NEW_MSG",
  SET_MSG_DELIVERED: "MSG:SET_MSG_DELIVERED",
  SET_MSG_NOT_DELIVERED: "MSG:SET_MSG_NOT_DELIVERED",
  SET_MSGS_READED: "MSG:SET_MSGS_READED",
  SET_BLACK_LIST: "MSG:SET_BLACK_LIST",
  SET_ALL_DIALOGS: "MSG:SET_ALL_DIALOGS",
  SET_USER_UNARCHIVED: "MSG:SET_USER_UNARCHIVED",
  ADD_NEW_DIALOG: "MSG:ADD_NEW_DIALOG",
  REMOVE_NEW_DIALOG: "MSG:REMOVE_NEW_DIALOG",
  UPDATE_FOLDERS_COUNTERS_REALTIME: "MSG:UPDATE_FOLDERS_COUNTERS_REALTIME",
  UPDATE_FOLDERS_COUNTERS_OPEN_CONVERSATION: "MSG:UPDATE_FOLDERS_COUNTERS_OPEN_CONVERSATION",
  SET_IS_NEW_MSG_RECEIVED: "MSG:SET_IS_NEW_MSG_RECEIVED",
  SET_IS_ONLINE: "MSG:SET_IS_ONLINE",
  SET_DIALOG_READED: "MSG:SET_DIALOG_READED",
  SET_MSG_SNIPPETS: "MSG:SET_SNIPPETS",
  TOGGLE_CONTACT_MESSAGE: "MSG:TOGGLE_CONTACT_MESSAGE",
  SET_MSG_COUNTER: "MSG:SET_COUNTER",
  REDUCE_MSG_COUNTER: "MSG:REDUCE_COUNTER",
  DELETE_CHAT_FROM_DIALOGS: "MSG:DELETE_CHAT_FROM_DIALOGS",
  UPDATE_DIALOG: "MSG:UPDATE_DIALOG",
  SET_SNIPPET_READED: "MSG:READ_SNIPPET",
  SET_MSG_FROM_OTHER_DEVICE: "MSG:GET_MSG_FROM_OTHER_DEVICE",
  UPDATE_LOSTED_MSGS: "MSG:UPDATE_LOSTED_MSGS",
  SET_CSS_HEIGHT_MSGS_LIST: "MSG:SET_CSS_HEIGHT_MSGS_LIST",
  SET_IS_OPEN_MESSAGES: "MSG:SET_IS_OPEN_MESSAGES",
  SET_FOLDER_ID: "MSG:SET_FOLDER_ID",
  SET_MY_MSG_TEXT: "MSG:SET_MY_MSG_TEXT",
  SET_ERROR_ID_MESSAGES: "MSG:SET_ERROR_ID_MESSAGES",
  RESET_ERROR_ID_MESSAGES: "MSG:RESET_ERROR_ID_MESSAGES",
  SET_SNIPPET_LOADING: "MSG:SET_SNIPPET_LOADING",
  RESET_MSG_CNT_FOR_CURRENT_DIALOG: "MSG:RESET_MSG_CNT_FOR_CURRENT_DIALOG",
  SET_RESET_MY_MESSAGE: "MSG:SET_RESET_MY_MESSAGE",
  SET_LOADING_DIALOGS: "MSG:SET_LOADING_DIALOGS",
  SET_MSG_REALTIME_SNIPPETS: "MSG:SET_MSG_REALTIME_SNIPPETS",
  SET_UPDATE_TEXT_LAST_EDITING_MESSAGE_IN_DIALOGS_SIDEBAR: "MSG:SET_UPDATE_TEXT_LAST_EDITING_MESSAGE_IN_DIALOGS_SIDEBAR",
  EDITED_TEXT_SNIPPET_MESSAGE: "MSG:EDITED_TEXT_SNIPPET_MESSAGE",
};

export type folderType = {
  folder: {
    id: number;
    name: string;
  }
  unreadMessage?: number;
}

export type msgMediaType = "Photo" | "Audio"

export type dialogType = {
  id: string;
  idSender: string;
  idRecipient: string;
  replyTo: number;
  time: string;
  edit?: boolean;
  text: string;
  mediaType?: msgMediaType;
  readStatus?: boolean;
  previewUserInfo: previewUserInfo;
  folderExists: Array<number>;
  countUnreadMessages: number;
  mainPhotoVerifiedStatus?: number;
  systemBanStatus?: boolean;
  deletedDate?: string;
}

export type previewUserInfo = {
  id: string;
  name: string;
  birthday: string;
  city: string;
  country?: string;
  photoSmall: string;
  isOnline?: boolean;
  isBlocked: boolean;
  isArchived: boolean;
  isFav: boolean;
  isMeBlocked?: boolean;
  mainPhotoVerifiedStatus?: number;
  systemBanStatus: boolean;
  deletedDate: string;
}

export type messageType = {
  id: number;
  idSender: string;
  idRecipient: string;
  replyTo?: number;
  time: string;
  edit?: boolean;
  text?: string;
  mediaType?: msgMediaType;
  readStatus?: boolean;
  photosNormal?: Array<string>;
  photosLarge?: Array<string>;
  error?: boolean;
  // оптимистичное сообщение с фото ещё грузится (до ответа sendMessage)
  pending?: boolean;
  systemMessageType?: messageSystemType;
  date?: string;
  milliseconds: number;
}

export type writingMessageType = {
  idUser: string;
  idProfile: string;
  text?: string;
  replyTo?: number;
  mediaType?: string;
}

export const MSG_PAGINATION_STEP = 50

export const foldersIds = {
  all: -1,
  favs: -2,
  archive: -3,
  blackList: -4
}

export const folderLocaleKey = (id: number): string | null => {
  switch (id) {
    case foldersIds.all: return "messages.folderAll";
    case foldersIds.favs: return "messages.folderFavs";
    case foldersIds.archive: return "messages.folderArchive";
    case foldersIds.blackList: return "messages.folderBlacklist";
    default: return null;
  }
}

export const statusesMessage = {
  ok: 201,
  contactFail: 132,
  premiumFail: 120
}

export type countersType = {
  [key: number]: [value: number]
}

export enum systemMessageTypes {
  ban = "USER_BAN",
  accessPhotos = "ACCESS_PRIVATE_PHOTO",
  approveAccessPhotos = "APPROVE_ACCESS_PRIVATE_PHOTO",
  none = "None"
}

export type snippetType = {
  lastMessage: {
    idSender: string,
    text: string,
    readStatus: boolean
  },
  previewUser: {
    mainPhoto: {
      photoLarge: string,
      photoNormal: string,
      photoSmall: string,
      photoCropNormal?: string,
      photoCropSmall?: string,
    },
    mainPhotoVerifiedStatus: string,
    onlineStatus: {
      online: boolean,
      lastTimeActivity: string
    },
    previewUserInfo: previewUserInfo
  },
  userStatus?: {
    systemBanStatus: number,
    deletedDate: string,
  },
}